import { getEnv, getNodeEnv } from '@/env';

const normaliseAppEnv = value => {
    if (typeof value !== 'string') {
        return '';
    }

    return value.trim().toLowerCase();
};

const inlineManualSiteIdByEnv = {
    local: getEnv('VUE_APP_INLINE_MANUAL_LOCAL_SITE_ID'),
    staging: getEnv('VUE_APP_INLINE_MANUAL_STAGING_SITE_ID'),
    demo: getEnv('VUE_APP_INLINE_MANUAL_DEMO_SITE_ID'),
    live: getEnv('VUE_APP_INLINE_MANUAL_LIVE_SITE_ID')
};

const resolveInlineManualSiteId = () => {
    const appEnv = normaliseAppEnv(getEnv('VUE_APP_ENV'));
    return inlineManualSiteIdByEnv[String(appEnv)] || getEnv('VUE_APP_INLINE_MANUAL_SITE_ID');
};

const config = {
    ENV: getNodeEnv(),
    /**
     * API
     */
    API_BASE_URL: getEnv('VUE_APP_API_BASE_URL', 'https://api.growthinvest.localhost'),
    API_TIMEOUT: parseInt(getEnv('VUE_APP_API_TIMEOUT')) || 30000,
    // API_LIFETIME uses no VUE_APP_ prefix; must be VITE_API_LIFETIME in .env for Vite.
    API_LIFETIME: parseInt(getEnv('VITE_API_LIFETIME', getEnv('API_LIFETIME'))) || 5000,
    /**
     * Application
     */
    APP_ENV: getEnv('VUE_APP_ENV'),
    APP_BASE_URL: getEnv('VUE_APP_BASE_URL', 'https://app.growthinvest.localhost'),
    APP_MAX_ONBOARDING_INVESTOR_TYPE_ATTEMPTS: parseInt(getEnv('VUE_APP_MAX_ONBOARDING_INVESTOR_TYPE_ATTEMPTS')) || 3,
    APP_FILTER_STORAGE: getEnv('VUE_APP_FILTER_STORAGE', 'localStorage'), // url, localStorage
    APP_EVENT_SUPPRESSION_KEY: getEnv('VUE_APP_EVENT_SUPPRESSION_KEY', 'suppress_events'),
    APP_PLATFORM_LOAD_TIMEOUT: parseInt(getEnv('VUE_APP_PLATFORM_LOAD_TIMEOUT')) || 45000,
    /**
     * I18N
     */
    I18N_LOCALE: getEnv('VUE_APP_I18N_LOCALE', 'en'),
    I18N_LOCALE_FALLBACK: getEnv('VUE_APP_I18N_FALLBACK_LOCALE', 'en'),
    /**
     * Freshdesk
     * FRESHDESK_WIDGET_ID uses no VUE_APP_ prefix; must be VITE_FRESHDESK_WIDGET_ID in .env for Vite.
     */
    FRESHDESK_WIDGET_ID: getEnv('VITE_FRESHDESK_WIDGET_ID', getEnv('FRESHDESK_WIDGET_ID')),
    /**
     * Ideal Postcodes
     */
    IDEAL_POSTCODES_API_KEY: getEnv('VUE_APP_IDEAL_POSTCODES_API_KEY'),
    /**
     * Sentry DSN
     */
    SENTRY_DSN: getEnv('VUE_APP_SENTRY_DSN'),
    /**
     * Sentry Auth Token
     */
    SENTRY_AUTH_TOKEN: getEnv('VUE_APP_SENTRY_AUTH_TOKEN'),
    /**
     * Sentry Organisation Slug
     */
    SENTRY_ORGANISATION_SLUG: getEnv('VUE_APP_SENTRY_ORGANISATION_SLUG', 'growthinvest'),
    /**
     * Sentry Project Slug
     */
    SENTRY_PROJECT_SLUG: getEnv('VUE_APP_SENTRY_PROJECT_SLUG', 'frontend'),
    /**
     * Sentry Browser Tracing
     */
    SENTRY_BROWSER_TRACING: [1, '1', true, 'true'].includes(getEnv('VUE_APP_SENTRY_BROWSER_TRACING')),
    /**
     * Sentry Browser Profiling
     */
    SENTRY_BROWSER_PROFILING: [1, '1', true, 'true'].includes(getEnv('VUE_APP_SENTRY_BROWSER_PROFILING')),
    /**
     * Sentry Session Replay
     */
    SENTRY_SESSION_REPLAY: [1, '1', true, 'true'].includes(getEnv('VUE_APP_SENTRY_SESSION_REPLAY')),
    /**
     * Allotment Tolerance
     */
    ALLOTMENT_AMOUNT_TOLERANCE: parseFloat(getEnv('VUE_APP_ALLOTMENT_AMOUNT_TOLERANCE')) || 0.01,
    /**
     * Inline Manual site API key (Portal: Site → Settings → Player installation).
     *
     * Environment-based keys:
     * - local   => VUE_APP_INLINE_MANUAL_LOCAL_SITE_ID
     * - staging => VUE_APP_INLINE_MANUAL_STAGING_SITE_ID
     * - demo    => VUE_APP_INLINE_MANUAL_DEMO_SITE_ID
     * - live    => VUE_APP_INLINE_MANUAL_LIVE_SITE_ID
     *
     * Falls back to VUE_APP_INLINE_MANUAL_SITE_ID for backwards compatibility.
     */
    INLINE_MANUAL_SITE_ID: resolveInlineManualSiteId()
};

export default config;
